import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import EsLogo from 'components/shared/icons/EsLogo';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
  },
  logoWrapper: {
    position: 'relative',
    width: theme.typography.pxToRem(130),
    height: theme.typography.pxToRem(130),
  },
  logo: {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: theme.typography.pxToRem(80),
    position: 'absolute',
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  loaderBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    borderTop: '0.2em solid rgba(255,255,255,0.2)',
    borderRight: '0.2em solid rgba(255,255,255,0.2)',
    borderBottom: '0.2em solid rgba(255,255,255,0.2)',
    borderLeft: '0.2em solid rgba(255,255,255,0.75)',
    animation: '$loader 1.1s infinite linear',
  },
  esLogo: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(1.5),
  },
  '@keyframes loader': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

export default function LoadingSpinner({ open, er }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div className={classes.logoWrapper}>
        <div className={classes.logo}>
          {er
            ? <img src="/imgs/logo.png" alt="EagleRider" />
            : <EsLogo classes={{ root: classes.esLogo }} />}
        </div>
        <div className={classes.loaderBorder} />
      </div>
    </Backdrop>
  );
}
